export default "assets/images/6d459846f6e18d7631f1ea2b52dcf85d.png";